module.exports = __webpack_public_path__ + "static/media/monitor.11aa73ff.png";